import { useState, useMemo, useEffect } from 'react';
import { Button, Card, Grid, Stack, TextField, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const FILTER_TYPES = {
  PENDING: 'pending',
  VALIDATED: 'validated',
};

const FilterCompanies = ({ allCompanies, onFilteredCompaniesChange }) => {
  const { t } = useTranslation();

  const [searchTerm, setSearchTerm] = useState('');
  const [actualFilter, setActualFilter] = useState('');

  const filteredCompanies = useMemo(() => {
    let filtered = [...allCompanies];

    if (actualFilter === FILTER_TYPES.PENDING) {
      filtered = filtered.filter((company) => !company.validated_at);
    } else if (actualFilter === FILTER_TYPES.VALIDATED) {
      filtered = filtered.filter((company) => company.validated_at);
    }

    if (searchTerm.trim()) {
      filtered = filtered.filter((company) =>
        company.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    return filtered;
  }, [allCompanies, actualFilter, searchTerm]);

  useEffect(() => {
    onFilteredCompaniesChange(filteredCompanies);
  }, [filteredCompanies, onFilteredCompaniesChange]);

  const clearFilters = () => {
    setSearchTerm('');
    setActualFilter('');
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <Grid item xs={12}>
      <Card sx={{ p: 2 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="start"
          fullWidth
          spacing={2}>
          <TextField
            size="small"
            placeholder={t('validations.common.filter.searchByName')}
            label={t('validations.common.filter.searchByName')}
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{ minWidth: 200 }}
          />
          <Button
            variant="outlined"
            size="small"
            onClick={() => setActualFilter(FILTER_TYPES.PENDING)}>
            {t('validations.common.filter.show', {
              label: t('validations.common.filter.pending'),
            })}
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={() => setActualFilter(FILTER_TYPES.VALIDATED)}>
            {t('validations.common.filter.show', {
              label: t('validations.common.filter.validated'),
            })}
          </Button>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          pt={1}>
          <Stack direction="row">
            {actualFilter && (
              <Chip
                key={actualFilter}
                label={t(`validations.common.filter.${actualFilter}`)}
              />
            )}
          </Stack>
          <Button variant="outlined" size="small" onClick={clearFilters}>
            {t('validations.common.filter.clear')}
          </Button>
        </Stack>
      </Card>
    </Grid>
  );
};

export default FilterCompanies;
